import { Divider } from '@mui/material';
import { lazy } from 'react';
import AdminActions from './AdminActions';
import { LangSelector } from './LangSelector';
import User from './User';

const CartAppBarAction = lazy(
  () => import('../../ecom/cart/CartPopper/CartAppBarAction')
);
const DeliveryPointAppBarAction = lazy(
  () => import('../../ecom/deliveryPoint/DeliveryPointAppBarAction')
);

export default [
  <User key="user" />,
  <AdminActions key="admin-actions" />,
  <LangSelector key="lang-selector" />,
  <Divider orientation="vertical" sx={{ mx: 2 }} key="divider" />,
  <CartAppBarAction key="cart" />,
  <DeliveryPointAppBarAction key="delivery-point" />,
];
